import { useTranslation } from 'react-i18next'

import { PageHeader } from 'components/Header'
import Loading from 'components/Loading'
import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { useAbility } from 'providers/casl'
import { useGetConnection } from './hooks/useGetConnection'
import { ConnectionStatusSection } from './sections/ConnectionStatusSection'
import { GoogleAdManagerIdSection } from './sections/GoogleAdManagerIdSection'
import { KeyValuesSection } from './sections/KeyValuesSection'
import { SetupPrebidStackSection } from './sections/SetupPrebidStackSection'
import { SetupRetargetingDeliveryItemsSection } from './sections/SetupRetargetingDeliveryItems'

export const GoogleAdManagerConnectionPage = (): React.JSX.Element => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection',
  })

  const { connection, loading } = useGetConnection()

  const disabledSection: boolean = !connection || connection.status !== 'completed'

  const { isFeatureEnabled: with2798 } = useFeatureFlag('yp2798GamOrderRetargetingDealsDeliveries')

  return (
    <>
      <PageHeader title={t('header')} />

      <GoogleAdManagerIdSection />

      {loading ? <Loading /> : <ConnectionStatusSection connection={connection} />}

      <KeyValuesSection disabled={disabledSection} />

      <SetupPrebidStackSection />

      {with2798 &&
        ability.can(
          'read',
          'GlobalSetupFeature-googleAdManagerConnection-setupRetargetingDeliveryItems',
        ) && <SetupRetargetingDeliveryItemsSection disabled={disabledSection} />}
    </>
  )
}
